export const buildOwnerStatementPath = (ownerCode) => `/owners/statements/${encodeURIComponent(ownerCode || '')}`;

export const buildOwnerCarsPath = (ownerCode) => `/owners/cars/${encodeURIComponent(ownerCode || '')}`;

export const buildCarPath = (plateNo) => `/cars/${encodeURIComponent(plateNo || '')}`;

export const buildOwnerTransactionPath = (ownerCode, transId) => (
  `/owners/transactions/${encodeURIComponent(ownerCode || '')}/${encodeURIComponent(transId || '')}`
);

